/*--------------------------------------------------------------
 ## Main Index File
 --------------------------------------------------------------*/

import "./scripts.js";
import "./app.js";



// WEBPACK FOOTER //
// ./src/assets/js/index.js